/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from '../../actions/modalActions';
import {
  addWrapParent,
  resetWrapParent,
  removeWrapParent
} from '../../actions/workPackageActions';
import SimpleTask from '../Tasks/simpleTask';
import ParentCard from './parentCard';

class WrapCard extends React.Component {
  constructor() {
    super();
    this.onCloseModal = this.onCloseModal.bind(this);
    this.removeParent = this.removeParent.bind(this);
  }

  onCloseModal() {
    this.props.resetWrapParent();
    this.props.closeModal(null, 'wrapCard');
  }

  removeParent(parentId) {
    if (
      this.props.parents.length > 0 &&
      this.props.parents[0].id === parentId
    ) {
      this.props.closeModal(null, 'wrapCard');
    }
    this.props.removeWrapParent(parentId);
  }

  render() {
    const { parents, item, type, posy, posx, users } = this.props;
    let taskOwners = [];
    if (type === 'task') {
      taskOwners = users.filter(
        user => item.task_owner_ids.indexOf(user.id) !== -1
      );
    }
    let allCards = null;
    parents.forEach((parent, index) => {
      if (index === 0) {
        allCards = (
          <ParentCard
            key={parent.id}
            result={parent}
            addParent={this.props.addWrapParent}
            removeParent={this.removeParent}
          >
            {type === 'task' && (
              <SimpleTask
                task={item}
                workPackage={parent}
                owners={taskOwners}
              />
            )}
            {type === 'story' && <ParentCard isFirst result={item} />}
          </ParentCard>
        );
      } else {
        allCards = (
          <ParentCard
            key={parent.id}
            result={parent}
            addParent={this.props.addWrapParent}
            removeParent={this.removeParent}
          >
            {allCards}
          </ParentCard>
        );
      }
    });

    if (!item && !item.id) return null;
    return (
      <div
        className="detail-modal team-modal"
        tabIndex="-1"
        role="dialog"
        onClick={this.onCloseModal}
      >
        <div
          className="detail-dialog"
          role="document"
          style={{
            position: 'absolute',
            top: posy - 14,
            left: posx - 97,
            width: 'initial',
            boxShadow: '0 0 15px #444444'
          }}
        >
          {allCards}
        </div>
      </div>
    );
  }
}

WrapCard.propTypes = {
  parents: PropTypes.array,
  item: PropTypes.object,
  posx: PropTypes.number,
  posy: PropTypes.number
};

const mapStateToProps = state => ({
  parents: state.workPackageReducer.parents,
  users: state.userReducer.users
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closeModal,
      addWrapParent,
      resetWrapParent,
      removeWrapParent
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrapCard);
